import {gsap, ScrollTrigger} from "gsap/all";

gsap.registerPlugin(ScrollTrigger);
gsap.config({nullTargetWarn: false});

class contentWithEyeAnimInit {
    constructor() {
        this.target = [...document.querySelectorAll('.section-content-with-eye')];
        if(this.target.length > 0) this.init();
    }

    init() {
        this.mainAnimations();
        ScrollTrigger.addEventListener("refreshInit", () => {
            this.debounce(this.mainAnimations, 300)
        })
    }

    debounce(func, delay) {
        let timer;
        return (args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    mainAnimations() {
        ScrollTrigger.getAll().forEach(ST => {
            if (ST.trigger.classList.contains('section-content-with-eye') || ST.trigger.classList.contains('section-content__wrap')) ST.kill();
        });

        [...this.target].forEach((section) => {
            let mainPosition = false;
            let smallPosition = false;

            const next = section.nextElementSibling;

            let mm = gsap.matchMedia();
            mm.add("(min-width: 1024px)", () => {
                gsap.timeline({
                    paused: true,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: section,
                        start: "top top",
                        end: "+=200%",
                        toggleActions: "play none none reverse",
                        scrub: true,
                        pin: true,
                        invalidateOnRefresh: -1,


                        onEnter: () => {
                            const eyeCircleMain = section.querySelector('.circle');
                            mainPosition = mainPosition ? mainPosition : eyeCircleMain.getBoundingClientRect();
                            gsap.set(eyeCircleMain, {transformOrigin: '50% 50%'});

                            window.addEventListener('mousemove', (e) => gsap.to(eyeCircleMain, {
                                ease: 'none',
                                duration: 0,
                                rotation: (Math.atan2(mainPosition.y + mainPosition.height / 2 - e.clientY, mainPosition.x + mainPosition.width / 2 - e.clientX) * 180) / Math.PI,
                                xPercent: (((e.clientX - mainPosition.x) / 100) * 2),
                                yPercent: (((e.clientY - mainPosition.y) / 100) * 2),
                            }));
                        }
                    },
                });

                gsap.timeline({
                    paused: true,
                    ease: 'ease',
                    scrollTrigger: {
                        trigger: section,
                        start: "top top",
                        end: "+=200%",
                        toggleActions: "play none none reverse",
                        scrub: true,
                        invalidateOnRefresh: -1,
                    }
                }).to(section.querySelector('.section-content__wrap'), {yPercent: -78, ease: 'none'});
            })
        });
    }
}

export default contentWithEyeAnimInit;
